<template>
  <router-link tag="li" class="nav-item nav-dropdown nav-dropdown-parent" :to="url" :id="name" disabled>
    <div class="nav-link nav-dropdown-toggle" @click="handleClick" :key="url"><i :class="icon"></i> {{name}}</div>
    <ul class="nav-dropdown-items">
      <slot></slot>
    </ul>
  </router-link>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (e) {
      e.preventDefault()
      let lost = e.target.parentElement.classList[3]
      if(lost == 'nestedClass') {
        jQuery(".nav-item").find('.nestedClass').not(e.target.parentElement).removeClass('open');
        e.target.parentElement.classList.toggle('open')
      } else {
        jQuery(".nav-item").find('.nav-dropdown-parent.open').not(e.target.parentElement).removeClass('open');
        e.target.parentElement.classList.toggle('open')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/SidebarNavDropdown.vue?5998cdfc